module.exports = __webpack_public_path__ + "static/media/email-logo-01.7b9935fe.png";